import api from '../../components/api'
import { JobPricingSettings } from './jobPricingSettings'

export type SetJobPricingSettingsRequest = {
  enabled: boolean
  acceptedSurchargeDisclaimer: boolean
}

export const getJobPricingSettings = async (jobId: number): Promise<JobPricingSettings> =>
  (await api.get<JobPricingSettings>(`/web/jobs/${jobId}/payment-method-pricing`)).data

export const setJobPricingSettings = async (jobId: number, request: SetJobPricingSettingsRequest): Promise<void> => {
  await api.post(`/web/jobs/${jobId}/payment-method-pricing`, request)
}
